var jqPropertyGrid =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__webpack_require__(3);

var OTHER_GROUP_NAME = 'Other';
var GET_VALS_FUNC_KEY = 'pg.getValues';
var pgIdSequence = 0;

/**
 * Generates the property grid
 * @param {object} obj - The object whose properties we want to display
 * @param {JQPropertyGridOptions} options - Options object for the component
 */

$.fn.jqPropertyGrid = function (obj, options) {
	// Check if the user called the 'get' function (to get the values back from the grid).
	if (typeof obj === 'string' && obj === 'get') {
		if (typeof this.data(GET_VALS_FUNC_KEY) === 'function') {
			return this.data(GET_VALS_FUNC_KEY)();
		}
		return null;
	} else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
		console.error('jqPropertyGrid 1st parameter must be a JS data object to initialize the grid.');
		return;
	} else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' || options === null) {
		console.error('jqPropertyGrid 2nd parameter must be a JS object defining the grid display options.');
		return;
	}

	// Normalize options
	loadStandardTypes(options);
	options.customTypes = options.customTypes || {};
	var meta = options.meta;

	// Seems like we are ok to create the grid
	var groupHTML = {};
	var postCreateInitFuncs = [];
	var getValueFuncs = {};
	var pgId = 'pg' + pgIdSequence++;

	// LOOP through all properties in the DATA OBJECT
	for (var prop in obj) {
		// Skip if this is not a direct property, a function, or its meta says it's non browsable
		if (!obj.hasOwnProperty(prop) || typeof obj[prop] === 'function' || meta[prop] && meta[prop].browsable === false) {
			continue;
		}

		// If this is the first time we run into this group create the group row
		var currGroup = meta[prop] && meta[prop].group || OTHER_GROUP_NAME;
		if (groupHTML[currGroup] === undefined) {
			groupHTML[currGroup] = getGroupHeaderRowHtml(currGroup);
		}

		// Append the current cell html into the group html
		groupHTML[currGroup] += getPropertyRowHtml(pgId, prop, obj[prop], meta[prop], postCreateInitFuncs, getValueFuncs, options);
	}

	// Now we have all the html we need, just assemble it
	var innerHTML = '<table class="pgTable">';
	for (var group in groupHTML) {
		if (group == OTHER_GROUP_NAME) continue;
		innerHTML += groupHTML[group];
	}

	// Finally add the "Other" group to the end
	if (groupHTML[OTHER_GROUP_NAME]) {
		innerHTML += groupHTML[OTHER_GROUP_NAME];
	}

	// Close the table and apply it to the div
	innerHTML += '</table>';
	this.html(innerHTML);

	// Now that HTML is in the DOM, run any post-init functions
	for (var i = 0; i < postCreateInitFuncs.length; ++i) {
		if (typeof postCreateInitFuncs[i] === 'function') {
			postCreateInitFuncs[i]();
		}
	}

	// Create a function that will return the values back from the property grid
	this.data(GET_VALS_FUNC_KEY, function () {
		var result = {};
		for (var prop in getValueFuncs) {
			if (typeof getValueFuncs[prop] !== 'function') continue;
			result[prop] = getValueFuncs[prop]();
		}
		return result;
	});
};

/**
 * Uses webpack to load all the standard types from the types folder into the global options.types object
 * @param {object} options - The global options object
 */
function loadStandardTypes(options) {
	options.types = {};
	var allTypes = __webpack_require__(4);
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = allTypes.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var typeFilename = _step.value;

			var regex = new RegExp("^\.\/(.*?)\.js$");
			var match = regex.exec(typeFilename);
			if (match !== null) {
				var typeName = match[1];
				options.types[typeName] = allTypes(typeFilename);
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

/**
 * Gets the html of a group header row
 * @param {string} displayName - The group display name
 */
function getGroupHeaderRowHtml(displayName) {
	return '<tr class="pgGroupRow"><td colspan="2" class="pgGroupCell">' + displayName + '</td></tr>';
}

/**
 * Gets the html of a specific property row
 * @param {string} pgId - The property-grid id being rendered
 * @param {string} name - The property name
 * @param {*} value - The current property value
 * @param {object} meta - A metadata object describing this property
 * @param {function[]} [postCreateInitFuncs] - An array to fill with functions to run after the grid was created
 * @param {object.<string, function>} [getValueFuncs] - A dictionary where the key is the property name and the value is a function to retrieve the property selected value
 * @param {object} options - The global options object
 */
function getPropertyRowHtml(pgId, name, value, originalMeta, postCreateInitFuncs, getValueFuncs, options) {
	var meta = $.extend(true, {}, originalMeta);
	var type = meta.type || '';
	var elemId = pgId + name;

	// if type not passed, infer type based on value...
	if (type === '') {
		if (typeof value === 'boolean') {
			type = 'boolean';
		} else if (typeof value === 'number') {
			type = 'number';
		}
	}

	// if jquery UI components aren't loaded fall back to plain inputs
	if (type === 'number' && typeof $.fn.spinner !== 'function') {
		type = 'input';
	} else if (type === 'color' && typeof $.fn.spectrum !== 'function') {
		type = 'input';
	}

	// Create "jquery form validator" html to be used later when generating INPUT HTML
	if (meta.validation) {
		meta.validationHTML = 'data-validation="' + meta.validation.rules + '"';
		$.each(meta.validation, function (key, value) {
			if (key === 'rules') {
				return true;
			} else if (key.startsWith('sanitize')) {
				var htmlAttribute = key.replace(/_/g, "-");
				meta.validationHTML += ' data-' + htmlAttribute + '="' + value + '"';
			} else {
				var htmlAttribute = key.replace(/_/g, "-");
				meta.validationHTML += ' data-validation-' + htmlAttribute + '="' + value + '"';
			}
		});
	} else {
		meta.validationHTML = '';
	}

	// Lookup the type or default to 'input'
	// Create the input HTML
	var thisType = options.customTypes[type] || options.types[type] || options.types['input'];
	var inputHTML = thisType.html(elemId, name, value, meta);

	// Create the label HTML
	var labelHTML = meta.name || name;
	var helpIcon = options.useFontAwesome ? '<i class="fa fa-question-circle-o"></i>' : '[?]';
	if (typeof meta.description === 'string' && meta.description && (typeof meta.showHelp === 'undefined' || meta.showHelp === true)) {
		labelHTML += '<span class="pgTooltip" title="' + meta.description + '">' + helpIcon + '</span>';
	}

	// Create post-DOM init functions & getValue functions
	if (thisType.hasOwnProperty('postCreateInitFunction')) {
		postCreateInitFuncs.push(thisType.postCreateInitFunction(elemId, name, value, meta));
	}
	if (thisType.hasOwnProperty('valueFunction')) {
		getValueFuncs[name] = thisType.valueFunction(elemId, name, value, meta);
	}

	// Finally assemble the HTML into 1 or 2 columns in a TR
	if (meta.colspan2 === true) {
		return '<tr class="pgRow"><td colspan="2" class="pgCell">' + inputHTML + '</td></tr>';
	} else {
		return '<tr class="pgRow"><td class="pgCell">' + labelHTML + '</td><td class="pgCell">' + inputHTML + '</td></tr>';
	}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./autonumeric.js": 5,
	"./boolean.js": 6,
	"./color.js": 7,
	"./input.js": 8,
	"./label.js": 9,
	"./mask.js": 10,
	"./number.js": 11,
	"./options.js": 12,
	"./textarea.js": 13
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// requires - https://github.com/autoNumeric/autoNumeric

module.exports = {
  html: function html(elemId, name, value, meta) {
    return '<input type="text" class="form-control" id="' + elemId + '" value="' + value + '" ' + meta.validationHTML + ' />';
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      var el = document.getElementById(elemId);
      var autoEl = AutoNumeric.getAutoNumericElement(el);
      // see different options @ https://github.com/autoNumeric/autoNumeric#methods
      // return autoEl.get();
      // return autoEl.getFormatted();
      // return autoEl.getNumber();
      return autoEl.get();
    };
  },
  postCreateInitFunction: function postCreateInitFunction(elemId, name, value, meta) {
    return function () {
      var options = meta.options || {};
      new AutoNumeric('#' + elemId, options);
    };
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {module.exports = {
  html: function html(elemId, name, value, meta) {
    var html = '<input type="checkbox" id="' + elemId + '" value="' + name + '"';
    html += value ? ' checked' : '';
    html += ' />';
    return html;
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      return $('#' + elemId).prop('checked');
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {module.exports = {
  html: function html(elemId, name, value, meta) {
    return '<input type="text" id="' + elemId + '" />';
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      return $('#' + elemId).spectrum('get').toHexString();
    };
  },
  postCreateInitFunction: function postCreateInitFunction(elemId, name, value, meta) {
    return function () {
      var opts = $.extend({}, meta.options);
      if (typeof value === 'string') {
        opts.color = value;
      }
      $('#' + elemId).spectrum(opts);
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {module.exports = {
  html: function html(elemId, name, value, meta) {
    return '<input type="text" class="form-control" id="' + elemId + '" value="' + value + '" ' + meta.validationHTML + ' />';
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      return $('#' + elemId).val();
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = {
  html: function html(elemId, name, value, meta) {
    if (typeof meta.description === 'string' && meta.description) {
      return '<label for="' + elemId + '" title="' + meta.description + '">' + value + '</label>';
    } else {
      return '<label for="' + elemId + '">' + value + '</label>';
    }
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      return value;
    };
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// requires - https://github.com/digitalBush/jquery.maskedinput
module.exports = {
  html: function html(elemId, name, value, meta) {
    return '<input type="text" class="form-control" id="' + elemId + '" value="' + value + '" ' + meta.validationHTML + ' />';
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      return $('#' + elemId).val();
    };
  },
  postCreateInitFunction: function postCreateInitFunction(elemId, name, value, meta) {
    if (typeof $.fn.mask === 'function') {
      var opts = $.extend({}, meta.options);

      // if not defined, default to autoclear
      if (typeof opts.autoclear === 'undefined') {
        opts.autoclear = false;
      }
      return function () {
        $('#' + elemId).mask(opts.mask, opts);
      };
    } else {
      console.error('$.fn.mask is NOT a function!');
      return null;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {module.exports = {
  html: function html(elemId, name, value, meta) {
    return '<input type="text" id="' + elemId + '" value="' + value + '" style="width:50px" />';
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      if (typeof $.fn.spinner === 'function') {
        return $('#' + elemId).spinner('value');
      } else {
        return $('#' + elemId).val();
      }
    };
  },
  postCreateInitFunction: function postCreateInitFunction(elemId, name, value, meta) {
    if (typeof $.fn.spinner === 'function') {
      var opts = $.extend({}, meta.options);
      // Add a handler to the change event to verify the min/max (only if not provided by the user)
      opts.change = typeof opts.change === 'undefined' ? onSpinnerChange : opts.change;

      return function () {
        $('#' + elemId).spinner(opts);
      };
    } else {
      return null;
    }
  }
};

/**
 * Handler for the spinner change event
 */
function onSpinnerChange() {
  var $spinner = $(this);
  var value = $spinner.spinner('value');

  // If the value is null and the real value in the textbox is string we empty the textbox
  if (value === null && typeof $spinner.val() === 'string') {
    $spinner.val('');
    return;
  }

  // Now check that the number is in the min/max range.
  var min = $spinner.spinner('option', 'min');
  var max = $spinner.spinner('option', 'max');
  if (typeof min === 'number' && this.value < min) {
    this.value = min;
    return;
  }

  if (typeof max === 'number' && this.value > max) {
    this.value = max;
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = {
  html: function html(elemId, name, value, meta) {
    selectedValue = value || '';
    options = meta.options || [];

    var html = '<select id="' + elemId + '">';
    for (var i = 0; i < options.length; i++) {
      var optionValue = _typeof(options[i]) === 'object' ? options[i].value : options[i];
      var text = _typeof(options[i]) === 'object' ? options[i].text : options[i];

      html += '<option value="' + optionValue + '"';
      html += selectedValue === optionValue ? ' selected>' : '>';
      html += text + '</option>';
    }
    html += '</select>';
    return html;
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      return $('#' + elemId).val();
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {module.exports = {
  html: function html(elemId, name, value, meta) {
    var html = '<textarea id="' + elemId;
    if (value instanceof Array) {
      html += '" rows=6 style="white-space: nowrap; overflow-x: auto; width:100%">';
      html += value.join("\n");
    } else {
      html += '" rows=6 style="overflow-x: auto; width:100%">';
      html += value;
    }
    html += '</textarea>';
    return html;
  },
  valueFunction: function valueFunction(elemId, name, value, meta) {
    return function () {
      if (value instanceof Array) {
        return $('#' + elemId).val().split('\n');
      } else {
        return $('#' + elemId).val();
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// jqPropertyGrid.js